import type { AdminWorkspaceSummary } from "../../api/adminDashboard";

const GENERIC_WORKSPACE_NAMES = new Set([
  "default workspace",
  "my workspace",
  "mitt arbeidsområde",
  "unnamed workspace",
]);

export const getCustomerAccountName = (
  workspace: AdminWorkspaceSummary,
): string => {
  if (workspace.companyNames.length === 1) {
    return workspace.companyNames[0];
  }
  if (workspace.companyNames.length > 1) {
    return `${workspace.companyNames[0]} +${workspace.companyNames.length - 1}`;
  }

  const workspaceName = workspace.name.trim();
  if (
    workspaceName &&
    !GENERIC_WORKSPACE_NAMES.has(workspaceName.toLocaleLowerCase())
  ) {
    return workspaceName;
  }
  return workspace.owner || `Workspace ${workspace.id.slice(0, 8)}`;
};

export const getCustomerAccountDetails = (
  workspace: AdminWorkspaceSummary,
): string => {
  if (workspace.companyNames.length > 0) {
    return workspace.owner;
  }
  return workspace.id.slice(0, 12);
};
